// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var BasicEnrollmentRace;
(function (BasicEnrollmentRace) {
    BasicEnrollmentRace["Asian"] = "Asian";
    BasicEnrollmentRace["Black"] = "Black";
    BasicEnrollmentRace["Multiple"] = "Multiple";
    BasicEnrollmentRace["NativeAmerican"] = "NativeAmerican";
    BasicEnrollmentRace["NativePacificIsles"] = "NativePacificIsles";
    BasicEnrollmentRace["Unknown"] = "Unknown";
    BasicEnrollmentRace["White"] = "White";
})(BasicEnrollmentRace || (BasicEnrollmentRace = {}));
//# sourceMappingURL=basicEnrollmentRace.js.map